// extracted by mini-css-extract-plugin
export default {"page-wrapper":"ApplicationTerms_page-wrapper__oNAQj","card-wrapper":"ApplicationTerms_card-wrapper__Dx1Nn"};